var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAffiliateDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-\xD0\xB3\xD1\x80\xD1\x83\xD0\xBF\xD0\xBF\xD0\xB0-\xD0\xBF\xD0\xB5\xD1\x80\xD0\xB5\xD0\xB4\xD0\xBD\xD0\xB5\xD0\xB3\xD0\xBE-\xD0\xBF\xD0\xBB\xD0\xB0\xD0\xBD\xD0\xB0-\xD0\xB2\xD1\x8B\xD0\xB1\xD1\x80\xD0\xB0\xD0\xBD\xD0\xBD\xD1\x8B\xD0\xB5 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.24967 8.33333C7.86051 8.33333 9.16634 7.0275 9.16634 5.41667C9.16634 3.80584 7.86051 2.5 6.24967 2.5C4.63884 2.5 3.33301 3.80584 3.33301 5.41667C3.33301 7.0275 4.63884 8.33333 6.24967 8.33333Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.7497 8.33333C15.3605 8.33333 16.6663 7.0275 16.6663 5.41667C16.6663 3.80584 15.3605 2.5 13.7497 2.5C12.1388 2.5 10.833 3.80584 10.833 5.41667C10.833 7.0275 12.1388 8.33333 13.7497 8.33333Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.75 11.6641H15.4167C17.025 11.6641 18.3333 12.9724 18.3333 14.5807C18.3333 16.1891 17.025 17.4974 15.4167 17.4974H8.75V11.6641Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.667 14.5807C11.667 16.1891 10.3587 17.4974 8.75033 17.4974H4.58366C3.78366 17.4974 3.05033 17.1724 2.52533 16.6391C1.99199 16.1141 1.66699 15.3807 1.66699 14.5807C1.66699 12.9724 2.97533 11.6641 4.58366 11.6641H8.75033C9.55033 11.6641 10.2837 11.9891 10.8087 12.5224C11.342 13.0474 11.667 13.7807 11.667 14.5807Z",
    fill: "#2894FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliateDefault);
export default __webpack_public_path__ + "static/media/affiliate-default.fcce8941fa4a12e61352394990945bfd.svg";
export { ForwardRef as ReactComponent };